import { Pipe, PipeTransform } from '@angular/core';
import { SoftwarePermissionCode } from 'src/app/core/models/permissions/permission-code';
import { User } from 'src/app/core/models/user/user.model';

@Pipe({
  name: 'hasEveryAccessGuestRoomPermissionInRole'
})
export class HasEveryAccessGuestRoomPermissionInRolePipe implements PipeTransform {

  transform(user: User): boolean {
    return user?.roles.some((role) => {
      return role.permissions.find(perm => perm.permissionCode == SoftwarePermissionCode.OdStaff)
    });

  }
}




